/*
 * SANEAMENTO DA FASE 2 — identidade do município nas telas.
 *
 * O SMGE é instalado para municípios diferentes. Antes, "PREFEITURA DE ÁGUAS DE LINDÓIA"
 * estava escrito no template de documentos (histórico escolar, declaração de
 * transferência). A identidade passa a vir do backend, que a resolve a partir de
 * `parametros_sistema` (`identidade.*`) ou, na falta, do cadastro real das escolas.
 *
 * NÃO é uma segunda fonte de verdade: este arquivo só busca e memoriza o que o backend
 * respondeu. Uma requisição por sessão de navegador, compartilhada por todos os
 * componentes que usarem o mixin.
 */

const PADRAO = {
  prefeitura: 'PREFEITURA MUNICIPAL',
  secretaria: 'SECRETARIA MUNICIPAL DE EDUCAÇÃO',
  municipio: null,
  uf: null,
  municipio_uf: null
}

// Cache de módulo: resolvido uma vez, reaproveitado por todas as telas.
let cache = null
let emVoo = null

export function carregarIdentidade (axios, baseUrl) {
  if (cache) return Promise.resolve(cache)
  if (emVoo) return emVoo

  emVoo = axios.get(`${baseUrl}/api/public/identidade`)
    .then(r => {
      const d = r.data || {}

      // Lê a resposta antes de usar: erro do backend não vira identidade.
      cache = (d.erro || d.error) ? Object.assign({}, PADRAO) : Object.assign({}, PADRAO, d)
      emVoo = null

      return cache
    })
    .catch(() => {
      // Sem rede, o documento ainda precisa sair — com o rótulo genérico, nunca com o
      // município de outra instalação.
      cache = Object.assign({}, PADRAO)
      emVoo = null

      return cache
    })

  return emVoo
}

/** Usado pelos testes e por quem alterar os parâmetros de identidade. */
export function limparCacheIdentidade () {
  cache = null
  emVoo = null
}

/**
 * Mixin: expõe `identidade` já preenchida com o padrão, e atualiza quando a resposta chega.
 * O componente nunca fica sem valor — não há estado intermediário em branco no documento.
 */
export const identidadeMixin = {
  data: () => ({ identidade: Object.assign({}, PADRAO) }),

  created () {
    carregarIdentidade(this.$axios, this.$store.state.config.baseUrlApi)
      .then(i => { this.identidade = i })
  }
}

export default identidadeMixin
